<script>
export default {
    inject: {
        iconSource: { default: '/img/icons/' }
    },
    props: {
        iconSrc: {
            type: String | Function,
            default() {
                return this.iconSource;
            }
        }
    },
    methods: {
        getIconSrc(icon) {
            const iconSrc = typeof this.iconSrc == 'string' ? this.iconSrc + icon : this.iconSrc(icon, this.iconSource);

            if(!iconSrc && this.iconSource != this.iconSrc) {
                return typeof this.iconSource == 'string' ? this.iconSource + icon : this.iconSource(icon, this.iconSrc);
            }

            return iconSrc;
        }
    }
}
</script>